import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/navigation-instruments/azimuth-thruster/azimuth-thruster.js';
      import {InstrumentState, Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
import {AngleAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/advice.js';
import {LinearAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/advice.js';
import {PropellerType} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/propeller.js';
import {TickmarkStyle} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/tickmark.js';

      export interface Props {
     angle?: number;
     angleSetpoint?: number | undefined;
     newAngleSetpoint?: number | undefined;
     atAngleSetpoint?: boolean;
     angleSetpointAtZeroDeadband?: number;
     angleSetpointOverride?: boolean;
     touching?: boolean;
     autoAtAngleSetpoint?: boolean;
     autoAtAngleSetpointDeadband?: number;
     animateSetpoint?: boolean;
     primaryTickmarkInterval?: number | undefined;
     secondaryTickmarkInterval?: number | undefined;
     tertiaryTickmarkInterval?: number | undefined;
     showLabels?: boolean;
     tickmarksInside?: boolean;
     thrust?: number;
     thrustSetpoint?: number | undefined;
     newThrustSetpoint?: number | undefined;
     atThrustSetpoint?: boolean;
     thrustSetpointAtZeroDeadband?: number;
     thrustSetpointOverride?: boolean;
     autoAtThrustSetpoint?: boolean;
     autoAtThrustSetpointDeadband?: number;
     state?: InstrumentState;
     priority?: Priority;
     loading?: number;
     hasLabelSpacer?: boolean;
     angleAdvices?: AngleAdvice[];
     thrustAdvices?: LinearAdvice[];
     singleDirection?: boolean;
     topPropeller?: PropellerType;
     bottomPropeller?: PropellerType;
     tickmarkStyle?: TickmarkStyle;
     starboardPortIndicator?: boolean
   }

      
  
      export type {InstrumentState, Priority} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/types.js';
export type {AngleAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/advice.js';
export type {LinearAdvice} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/advice.js';
export type {PropellerType} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/thruster/propeller.js';
export type {TickmarkStyle} from '@oicl/openbridge-webcomponents/dist/navigation-instruments/watch/tickmark.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcAzimuthThruster',
  props: {
    angle: {},
    angleSetpoint: {},
    newAngleSetpoint: {},
    atAngleSetpoint: { type: Boolean },
    angleSetpointAtZeroDeadband: {},
    angleSetpointOverride: { type: Boolean },
    touching: { type: Boolean },
    autoAtAngleSetpoint: { type: Boolean },
    autoAtAngleSetpointDeadband: {},
    animateSetpoint: { type: Boolean },
    primaryTickmarkInterval: {},
    secondaryTickmarkInterval: {},
    tertiaryTickmarkInterval: {},
    showLabels: { type: Boolean },
    tickmarksInside: { type: Boolean },
    thrust: {},
    thrustSetpoint: {},
    newThrustSetpoint: {},
    atThrustSetpoint: { type: Boolean },
    thrustSetpointAtZeroDeadband: {},
    thrustSetpointOverride: { type: Boolean },
    autoAtThrustSetpoint: { type: Boolean },
    autoAtThrustSetpointDeadband: {},
    state: {},
    priority: {},
    loading: {},
    hasLabelSpacer: { type: Boolean },
    angleAdvices: {},
    thrustAdvices: {},
    singleDirection: { type: Boolean },
    topPropeller: {},
    bottomPropeller: {},
    tickmarkStyle: {},
    starboardPortIndicator: { type: Boolean }
  },
  setup(__props: any) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-azimuth-thruster',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})